import SeoLandingLayout from "../../components/SeoLandingLayout";

export default function DiamondJewelleryMeerut() {
  return (
    <SeoLandingLayout
      testId="diamond-meerut-page"
      path="/diamond-jewellery-meerut"
      seoTitle="Diamond Jewellery in Meerut | Rings, Necklaces & Earrings | Ramesh Kapoor & Sons"
      seoDescription="Diamond jewellery in Meerut — rings, necklaces, earrings, bracelets and pendants with stone information explained plainly, at Ramesh Kapoor & Sons Jewellers, Abu Plaza, Meerut."
      crumbLabel="Diamond Jewellery Meerut"
      eyebrow="Diamonds"
      h1={<>Diamond Jewellery in <span className="italic text-[#C5A059]">Meerut</span></>}
      intro={[
        "Diamond jewellery asks more of a jeweller than gold does — the buyer cannot weigh a stone's quality by eye, and must rely on the house's explanation and word. At Ramesh Kapoor & Sons Jewellers Pvt. Ltd., diamond pieces are presented with their stone information explained in plain terms, and pricing set out component by component.",
        "Our diamond range is available at the Abu Plaza retail showroom in Meerut, and to the trade through our wholesale desks in Meerut and New Delhi.",
      ]}
      hero={{ src: "/images/jewellery-bridal.jpg", alt: "Diamond and gold bridal set displayed on velvet — diamond jewellery at Ramesh Kapoor & Sons, Meerut" }}
      sections={[
        {
          id: "the-diamond-range",
          eyebrow: "The Range",
          title: "Rings, Necklaces, Earrings, Bracelets, Pendants",
          paragraphs: [
            "The diamond range covers rings — including engagement and occasion rings — necklaces, earrings, bracelets and pendants, from restrained daily-wear pieces to full occasion sets. Designs move between traditional settings and contemporary minimal work, with weights and stone spreads suited to different budgets.",
            "Because the same house manufactures and wholesales, the diamond range benefits from the bench discipline described on our manufacturing page: secure settings and finishing built for years of wear.",
          ],
        },
        {
          id: "understanding",
          eyebrow: "Clarity",
          title: "Understanding What You Buy",
          paragraphs: [
            "Every diamond piece is explained the same way: the stones, the metal, the making and applicable taxes set out separately, so you always know what you are paying for. Buyers comparing diamond jewellery in Meerut should expect this level of plainness from any house — we simply practise it as routine.",
            "If you are choosing between pieces, our team will put them side by side and walk through the differences in stone presence, setting style and weight until the choice feels informed rather than rushed.",
          ],
        },
        {
          id: "everyday-to-occasion",
          eyebrow: "Wearing",
          title: "From Everyday to Occasion",
          paragraphs: [
            "Daily-wear diamond jewellery — studs, slender rings, small pendants — is chosen for secure settings and comfort. Occasion pieces — necklaces, bracelets, statement earrings — are chosen for presence. Both begin with the same conversation about how and when you will wear the piece.",
            "For wedding purchases, diamond sets are often planned alongside gold; our bridal jewellery page explains how families build a complete wedding selection with us.",
          ],
        },
      ]}
      faqs={[
        { q: "What diamond jewellery categories do you offer?", a: "Rings, necklaces, earrings, bracelets and pendants — from daily-wear pieces to occasion and bridal sets." },
        { q: "How is diamond jewellery priced?", a: "The value of the stones, the metal, the making charges and applicable taxes are set out separately and explained before purchase — never a single unexplained figure." },
        { q: "Do you have diamond rings for engagements in Meerut?", a: "Yes. Engagement and occasion rings are part of the range at our Abu Plaza showroom; book an appointment and share your budget so a selection is ready for you." },
        { q: "Can I see diamond pieces by appointment?", a: "Yes — appointments at the Abu Plaza showroom let our team prepare pieces around your occasion, budget and preferences in advance." },
        { q: "Is diamond jewellery available wholesale?", a: "Yes. Jewellers and retailers can enquire about diamond lines through our wholesale desk in Sarafa Bazaar, Meerut, or Karol Bagh, New Delhi." },
      ]}
      cta={{
        title: <>Compare stones side by side, <span className="italic text-[#C5A059]">unhurried.</span></>,
        buttons: [
          { to: "/jewellery/appointment", label: "Book an Appointment", primary: true },
          { to: "/jewellery/category/diamond-jewellery", label: "Browse Diamond Jewellery" },
        ],
      }}
      siblings={[
        { to: "/gold-jewellery-meerut", label: "Gold jewellery in Meerut" },
        { to: "/bridal-jewellery-meerut", label: "Bridal jewellery in Meerut" },
        { to: "/jewellery-meerut", label: "Jewellery in Meerut — overview" },
      ]}
    />
  );
}
